var map = {
	"./acti.gif": 127,
	"./activation-functions.gif": 128,
	"./neural.gif": 129,
	"./news.gif": 130,
	"./project-01.png": 131,
	"./project-02.png": 132,
	"./project-03.png": 133,
	"./project-04.png": 134,
	"./project-05.png": 135,
	"./project-06.png": 136,
	"./project-07.png": 137,
	"./project-BI.jpg": 138,
	"./project-NO2.jpg": 139,
	"./project-buddy.jpg": 140,
	"./project-car.jpg": 141,
	"./project-cups.jpg": 142,
	"./project-health.jpg": 143,
	"./project-monitoring.webp": 144,
	"./project-parser.avif": 145,
	"./project-rpa.jpg": 146,
	"./project-wikipedia.png": 147,
	"./voice.gif": 148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;